import effectManager from '../effect';
import Param from '../../param';

const param = new Param();
const effect = new effectManager();

export default class globalNavi{
    constructor(scroll){

        this.w;
        this.h;

        /* 必要なDOM */
        this.$header;

        this.$logo;
        this.$trigger;
        this.$container;
        this.$link;
        this.$hover;
        this.$bgCircle;
        this.$bgIllust;

        this.$show;


        /* 設定 */
        this.conf = {
        }

        /* ステータス */
        this.status = {
            now : "close",
            device : "pc",
            bg : {
                w : 0,
                h : 0,
                posi : {
                    x : 0,
                    y : 0,
                    closeX : 0,
                    closeY : 0
                }
            }
        }

        this.scroll;


    }
    init(scroll) {

        this.scroll = scroll;
        // console.log("gnavi",this.scroll.contents)

        this.$header =  document.getElementById("l-header");

        this.$logo = document.getElementById("l-header-logo");
        this.$trigger = document.getElementById("l-header-trigger");
        this.$submit = document.getElementById("l-header-submit");
        this.$container =  document.getElementById("l-header-navi");
        this.$link = this.$container.getElementsByClassName("js__link");
        this.$hover = document.getElementsByClassName("js__gnavi-hover")
        this.$bgCircle =  document.getElementById("l-header-navi-bg-color");
        this.$bgIllust =  this.$container.querySelectorAll(".bg-illust");

        this.$show = document.querySelectorAll(".js__gnavi-show");


        effect.show(this.$bgIllust,"set");
        effect.show(this.$show,"set");

        for(let i=0; i<this.$hover.length; i++){
            this.$hover[i].addEventListener("mouseenter", (e)=> {
                e.stopPropagation();
                let _select = e.target.getAttribute("data-target");
                let _$target = document.getElementById("l-header-navi-bg-hover-"+_select);

                effect.showSingle(_$target,"show-slowDown");

            });

            this.$hover[i].addEventListener("mouseleave", (e)=> {
                e.stopPropagation();
                let _select = e.target.getAttribute("data-target");
                let _$target = document.getElementById("l-header-navi-bg-hover-"+_select);
                effect.showSingle(_$target,"out");

            });
        }


        for(let i=0; i<this.$link.length; i++){
            this.$link[i].addEventListener("click", (e)=> {
                e.stopPropagation();
               this.close();
            });
        }


        this.$trigger.addEventListener("click",(e)=> {
            e.stopPropagation();
            if(this.status.now==="close"){
                this.open();
            }else{
                this.close();
            }
        });

        this.$logo.addEventListener("click",(e)=> {
            e.stopPropagation();
            if(this.status.now!="close"){
                this.close();
            }
        });

        // this.resize();


    }
    open(){

        this.status.now = "open";

        this.$container.classList.remove("is-close");
        this.$bgCircle.classList.add("is-show");

        TweenMax.set(this.$submit,{ zIndex:99 });

        TweenMax.killTweensOf(this.$bgCircle.children[2]);
        TweenMax.to(this.$bgCircle.children[2],0.8,{
            width:this.status.bg.w,
            height:this.status.bg.h,
            x : this.status.bg.posi.x*-1,
            y : this.status.bg.posi.y,
            opacity:1,
            ease: Power2.easeInOut,
            onComplete:()=>{
                TweenMax.set(this.$container,{ backgroundColor:"#fabe00" });
                this.scroll.changeMode("select",document.getElementById("l-header-navi"));
            }
            // ease: Power2.easeOut
        })


        setTimeout(()=> {

            this.$header.classList.add("is-open");
            this.$logo.classList.add("is-open");
            this.$trigger.classList.add("is-open");

            TweenMax.killTweensOf(this.$show);
            effect.show(this.$show, "show");

        },2e2);
    }
    close(){


        this.status.now = "close";
        this.$container.classList.add("is-close");
        TweenMax.killTweensOf(this.$show);
        effect.show(this.$show,"out");

        TweenMax.to(this.$bgCircle.children[2],0.5,{
            width:0,
            height:0,
            x:this.status.bg.posi.closeX*-1,
            y:this.status.bg.posi.closeY,
            opacity:0,
            delay:0.6,
            ease: Power2.easeIn,
            onStart:()=>{
                TweenMax.set(this.$container,{ backgroundColor:"transparent" });
            }
        })

        setTimeout(()=> {
            this.$logo.classList.remove("is-open");
            this.$trigger.classList.remove("is-open");
            this.$bgCircle.classList.remove("is-show");
            this.$header.classList.remove("is-open");
            this.scroll.changeMode("normal");
            TweenMax.set(this.$submit,{ delay:0.6,zIndex:102 });
            this.scroll.contents.status.sideBtn = true;
            this.scroll.resize(param.displayType);
        },5e2);
    }
    resize(){

        this.w = window.innerWidth;
        this.h = screen.height;

        // this.status.bg.posi.x = this.status.bg.posi.y = - this.status.bg.w;


        if(this.w>param.breakpoint){
            // if(this.status.device==="sp"&&this.status.now == "open") this.close();
            this.status.bg.w = this.status.bg.h = this.w>this.h?this.w*3:this.h*3;
            this.status.device = "pc";
            this.status.bg.posi.x = this.status.bg.posi.y = (28 - this.status.bg.w - 50) / 2;
            this.status.bg.posi.closeX = this.status.bg.posi.closeY = (28 - 50) / 2;
        }else{
            // if(this.status.device==="pc"&&this.status.now == "open") this.close();
            this.status.bg.w = this.status.bg.h = this.w>this.h?this.w*4:this.h*4;
            this.status.device = "sp";
            this.status.bg.posi.x = (20 - this.status.bg.w - 40) / 2 *-1;
            this.status.bg.posi.y = (20 - this.status.bg.w - 40) / 2;
            this.status.bg.posi.closeX = this.status.bg.posi.closeY = (20- this.status.bg.w - 40) / 2;
        }



        if(this.$bgCircle&&this.status.now==="close") {
            TweenMax.set(this.$bgCircle.children[2],{
                x:this.status.bg.posi.closeX*-1,
                y:this.status.bg.posi.closeY,
            })
        }else if(this.$bgCircle){
            TweenMax.set(this.$bgCircle.children[2],{
                x:this.status.bg.posi.x*-1,
                y:this.status.bg.posi.y,
            })
        }

    }
}